import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { takeUntil, first } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthenticationService } from 'app/auth/service';

import { CoreConfigService } from '@core/services/config.service';
import { CommunicationService } from '../../../../../services/communication.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-auth-register-v2',
  templateUrl: './auth-register-v2.component.html',
  styleUrls: ['./auth-register-v2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthRegisterV2Component implements OnInit {
  // Public
  public coreConfig: any;
  public passwordTextType: boolean;
  public registerForm: UntypedFormGroup;
  public submitted = false;
  public returnUrl: string;
  public error = '';

  public loadingButton = false;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    private _authenticationService: AuthenticationService,
    private _coreConfigService: CoreConfigService, 
    private _formBuilder: UntypedFormBuilder,
    private _router: Router,
    private _communicationService: CommunicationService,
    private _route: ActivatedRoute
    ) {
          // redirect to home if already logged in
    if (this._authenticationService.currentUserValue) {
      this._router.navigate(['/']);
    }

    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;
  }

  /**
   * Toggle password
   */
  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  /**
   * On Submit
   */
  onSubmit() {
    this.submitted = true;

    // Login
    this.loadingButton = true;

    if(this.f.checkbox.value == true){
        var info =
      {
        "customer_name": this.f.customer_name.value, 
        "customer_website": this.f.customer_website.value, 
        "user_firstName": this.f.user_firstName.value, 
        "user_email": this.f.user_email.value, 
        "user_phone": this.f.user_phone.value
      };

      this._communicationService.requestNewCustomer(info).then(data =>
        {
          var mydata:any = data;        
          this.loadingButton = false;          

          if (mydata.id > 1) {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: "Demo request has been submitted. Soon we will contact you.",
              showConfirmButton: true,
              allowOutsideClick: function () {
                return !Swal.isLoading();
                
              }
            });
            this._router.navigate(['/']);
          }else{
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: "The demo request was not sent. Try again.",
              showConfirmButton: true,
              allowOutsideClick: function () {
                return !Swal.isLoading();

              }
            });
          }


        }
      );


    }
    
    

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.registerForm = this._formBuilder.group({
      customer_name: ['', [Validators.required]],
      customer_address: ['', [Validators.required]],
      customer_email: ['', [Validators.required, Validators.email]],
      customer_phone: ['', [Validators.required]],
      customer_website: ['', [Validators.required]],
      user_firstName: ['', [Validators.required]],
      user_lastName: ['', [Validators.required]],
      user_email: ['', [Validators.required, Validators.email]],
      user_phone: ['', [Validators.required]],
      checkbox: ['', [Validators.required]],
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
